const IconLock = props => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.41666 5.41668C5.41666 2.88537 7.46869 0.833344 10 0.833344C12.5313 0.833344 14.5833 2.88537 14.5833 5.41668V7.50001C14.5833 7.96024 14.2102 8.33334 13.75 8.33334C13.2897 8.33334 12.9167 7.96024 12.9167 7.50001V5.41668C12.9167 3.80584 11.6108 2.50001 10 2.50001C8.38916 2.50001 7.08333 3.80584 7.08333 5.41668V7.50001C7.08333 7.96024 6.71023 8.33334 6.25 8.33334C5.78976 8.33334 5.41666 7.96024 5.41666 7.50001V5.41668Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5 6.87501C3.73426 6.87501 2.70821 7.90115 2.70833 9.16693L2.70902 16.6669C2.70914 17.9324 3.73512 18.9583 5.00069 18.9583H14.9998C16.2655 18.9583 17.2915 17.9323 17.2915 16.6667V9.16668C17.2915 7.90103 16.2655 6.87501 14.9998 6.87501H5ZM10.8333 12.0833C10.8333 11.6231 10.4602 11.25 10 11.25C9.53975 11.25 9.16666 11.6231 9.16666 12.0833V13.75C9.16666 14.2103 9.53975 14.5833 10 14.5833C10.4602 14.5833 10.8333 14.2103 10.8333 13.75V12.0833Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default IconLock;
